export const showCustomAnalytics = false;

export const TRACKING_ID = '';
export const CLIENT_ID = '';
export const SCOPES = ['https://www.googleapis.com/auth/analytics.readonly'];
export const GAPI_URL = "https://apis.google.com/js/api.js";
export const GAPI_AUTH_URL = "https://apis.google.com/js/client.js?onload=authorize";

export const JQUERY_URL = "https://code.jquery.com/jquery-3.4.1.js";
export const JQUERY_MIN_URL = "https://code.jquery.com/ui/1.12.1/jquery-ui.min.js";
export const LLGC_COOKIE_URL = "https://cookies.library.wales/cookie.js";
export const LLGC_ID = "llgc_cookie_control";
